var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-server-area" },
    [
      _c("header", [
        _c(
          "div",
          { attrs: { "data-role": "appbar", "data-expand-point": "md" } },
          [
            _c("a", { staticClass: "brand no-hover" }, [
              _vm._v("\n          Γιώργος Γκιζάρης\n      ")
            ]),
            _vm._v(" "),
            _c("main-menu")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "main-content" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("ui-blocker")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }